import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/api';
import { Validators, FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/api';
import { DialogService} from 'primeng/api';
import { NewmemberService } from '../../services/newmember.service';

@Component({
  selector: 'app-updatecontact',
  templateUrl: './updatecontact.component.html',
  styleUrls: ['./updatecontact.component.css'],
  providers: [DialogService]
})
export class UpdatecontactComponent implements OnInit {


  cardHolders = [];
  populateForm:any = {};
  uploadedFiles:any = {};
  ch:any = {};
  contactForm: FormGroup;
  contactFormValid: boolean = true;
  otpInfo: any = {};
  pNumber: any;
  addonList: any = [];
  otpFlag:boolean;
  primaryCardholderNbr: number;
  membershipValidity: string;
  cardHolderNbr:number;
  invalidMobileNumbarlist: any = [];

  constructor(public config: DynamicDialogConfig, public nms: NewmemberService, public messageService: MessageService, public ref: DynamicDialogRef) { }

  ngOnInit() {
  
    this.invalidMobileNumbarlist.push("4444444444");
    this.invalidMobileNumbarlist.push("5555555555");
    this.invalidMobileNumbarlist.push("6666666666");
    this.invalidMobileNumbarlist.push("7777777777");
    this.invalidMobileNumbarlist.push("8888888888");
    this.invalidMobileNumbarlist.push("9999999999");
    this.addonList = this.config.data.info;
    this.otpFlag = this.config.data.otpFlag;
    /*for(let c of this.config.data.info) {

      if(c.cardHolderNbr <= 100) {
        if((c.status == 'A' || c.status == 'ONHOLD') && (c.cardHolderType == 'P' || this.otpFlag)) {
          this.cardHolders.push(c);
        }
      }
      if(c.cardHolderType == 'P' && (c.status == 'A' || c.status == 'QC PENDING' || c.status == 'ONHOLD')) {
        this.pNumber = c.phoneNbr
      }
    }*/
    this.populateForm = this.config.data.populate;
    this.contactForm = new FormGroup({     
      phoneNbr: new FormControl('', Validators.compose([
        Validators.required
      ])),
      docType: new FormControl('', Validators.compose([
        Validators.required
      ])),
      membershipNbr: new FormControl('', Validators.compose([
        Validators.required
      ])),
      previousPhoneNbr: new FormControl(),
      cardHolderDocumentsParams: new FormControl(),
    });
    this.uploadedFiles.cardHolderDocumentsParams = [];
    this.uploadedFiles.cardHolderDocumentsParams.push({ "ustatus": false, "documentType": 'PHONENO CHANGE REQUEST LETTER' });
    this.uploadedFiles.cardHolderDocumentsParams.push({ "ustatus": false, "documentType": 'PHONENO CHANGE PHOTO PROOF' });
  }

  
  cardChange(e) {
    for(let c of this.cardHolders) {
      if(c.cardHolderNbr == e.value) {
      //  this.contactForm.patchValue({'previousPhoneNbr':c.phoneNbr});
      }
    }
  }

 

  onBlurMethod() {
    if (this.contactForm.get("membershipNbr").value) {
      if (this.contactForm.get("membershipNbr").value.length == 17) {
        this.membershipValidity = "INVALID";
        var inputNbr = this.contactForm.get("membershipNbr").value;
        if (inputNbr.indexOf("11734") < 0) {
          this.membershipValidity = "INVALID";
          this.messageService.add({ severity: 'info', summary: 'Membership', detail: 'Invalid Membership Number, Please contact nearest store.'});  
        } else {          
          var membershipNbr = inputNbr.substring(8,inputNbr.length).replace(/^0+/, '');
          var cardHolderNbr = inputNbr.substring(5,7);
          if (cardHolderNbr <= 20) {
            var requestInfo: any = {};
            requestInfo.membershipNbr = membershipNbr;
            requestInfo.cardHolderNbr = cardHolderNbr;
            this.cardHolderNbr = cardHolderNbr;
            this.nms.validateMembershipNbr(requestInfo).subscribe((res: any) => {
              if (res.code == "SUCCESS") {
                if(res.response.Status === "VALID") {
                  if (res.response.MemberStatus === 'QC PENDING' || res.response.CardStatus === 'QC PENDING') {
                    this.messageService.add({ severity: 'info', summary: 'Membership', detail: 'Membership / Card is inactive status, Please contact nearest store.'});
                    this.membershipValidity = "";
                  } else if (res.response.CardStatus === 'A' || res.response.CardStatus === 'ONHOLD') {
                    this.membershipValidity = "VALID";
                    this.nms.setDefault(membershipNbr, res.response.maMembershipId, res.response.MemberStatus);
                  } else {
                    this.messageService.add({ severity: 'info', summary: 'Membership', detail: 'Membership / Card is inactive status, Please contact nearest store.'});
                    this.membershipValidity = "";
                  }
                } else {                  
                  this.messageService.add({ severity: 'info', summary: 'Update phone number', detail: 'Invalid Membership Number, Please contact Nearest Store' });
                }
              } else {
                this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Error Validating Membership Number, Please contact Nearest Store.' });
              }
            }, err => {
              this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Error Validating Membership Number, Please contact Nearest Store.' });
            });
        } else if (cardHolderNbr < 100) {
          this.messageService.add({ severity: 'info', summary: 'Update phone number', detail: 'Only Primary member can change their phone number. Add-On members please contact your primary member or call for assistance.' });
        } else {
          this.messageService.add({ severity: 'info', summary: 'Update phone number', detail: 'Invalid Membership Number, Please contact Nearest Store' });
        }
      }
    } else {
      this.membershipValidity = "INVALID";
    }
  }
}

  

  phoneNumberUpdate(){
    
  }

  
  
  ustatusUpdate(event, group, type) {
    if (!this.uploadedFiles[group]) {
      this.uploadedFiles[group] = [];
      this.uploadedFiles[group].push({ "ustatus": event, "documentType": type });
    } else {
      let check = 0;
      for (let list of this.uploadedFiles[group]) {
        if (list.documentType == type) {
          check = 1;
          list.ustatus = event;
        }
      }
      if (check == 0) {
        this.uploadedFiles[group].push({ "ustatus": event, "documentType": type });
      }
    }
  }

  updateUploadstatus(event, group, type) {
    if (!this.uploadedFiles[group]) {
      this.uploadedFiles[group] = [];
      this.uploadedFiles[group].push({ "documentId": event.documentId, "documentType": type });
    } else {
      let done = 0;
      for (let list of this.uploadedFiles[group]) {
        if (list.documentType == type) {
          list.documentId = event.documentId;
          done = 1;
        }
      }
      if (done == 0) {
        this.uploadedFiles[group].push({ "documentId": event.documentId, "documentType": type });
      }
    }
  }

  isPhoneNumberUnique(phoneNbr, cardholderNbr) {
    if (this.addonList.length > 0) {
      var addOn = this.addonList.filter(proj => proj.phoneNbr === parseInt(phoneNbr));
      if (addOn[0] != null) {
        for (var index = 0; index < addOn.length; index++) {
          if (addOn[index].status != 'L' && addOn[index].status != 'R' && addOn[index].status != 'S') {
            if (addOn[index].cardHolderNbr != cardholderNbr){
              this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Mobile number is already used by another card holder(' + addOn[index].firstName + '), please change the mobile number.' });
              return false;
            } else if (addOn[index].cardHolderNbr == cardholderNbr && addOn[index].phoneNbr == phoneNbr){
              this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Same mobile number cannot be updated.' });
              return false;
            }
          }
        }
      }
    } 
    return true;
  }

  /*
  isPhoneNumberUnique(phoneNbr, cardholderNbr) {
    if (this.addonList.length > 0) {
      var addOn = this.addonList.filter(proj => proj.phoneNbr === parseInt(phoneNbr));
      if (addOn[0] != null) {
        if (addOn[0].cardHolderNbr != cardholderNbr){
          this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Mobile number is already used by another card holder, please change the mobile number.' });
          return false;
        } else {
          this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Same mobile number cannot be updated.' });
          return false;
        }
      }
    } 
    return true;
  }*/

  saveContact() {
    
    if(this.membershipValidity == "INVALID") {
      this.messageService.add({ severity: 'info', summary: 'Update phone number', detail: 'Invalid Membership Number, Please contact Nearest Store' });
      return;
    }
    if(this.membershipValidity == "") {
      this.messageService.add({ severity: 'info', summary: 'Membership', detail: 'Membership / Card is inactive status, Please contact nearest store.'});
      return;
    }
    if(this.contactForm.valid) {
      if (this.contactForm.get("phoneNbr").value) {
        var mobileNbr =  this.contactForm.get("phoneNbr").value;
        if (mobileNbr.toString().length != 10 || mobileNbr.toString().charAt(0) <= 4 
        || this.invalidMobileNumbarlist.indexOf(mobileNbr.toString()) >= 0) {
          this.messageService.add({ severity: 'info', summary: 'Membership', detail: 'Mobile number is not valid, Please verify the mobile number.'});
          return;
        }        
      }
      for(let l of this.uploadedFiles.cardHolderDocumentsParams) {
        if(!l.ustatus) {
          this.contactFormValid = false;
          this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Please enter all mandatory fields' });
          return;
        }
      }    
      
      let data:any = this.contactForm.value;
      data.cardHolderDocumentsParams = this.uploadedFiles.cardHolderDocumentsParams;
      data.cardHolderNbr = this.cardHolderNbr;
      this.nms.updateContact(data).subscribe((res: any) => {
        if (res.code == "SUCCESS") {
          this.messageService.add({ severity: 'success', summary: 'Update phone number', detail: 'Mobile number update request submitted.' });
          this.ref.close(true);
        }
      }, err => {
        this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'update failed' });
      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Please enter all mandatory fields' });
      this.contactFormValid = false;
    }
  }
}
